import { render, staticRenderFns } from "./CompetitionSelection.vue?vue&type=template&id=a1c24ed0&scoped=true&"
import script from "./CompetitionSelection.vue?vue&type=script&lang=js&"
export * from "./CompetitionSelection.vue?vue&type=script&lang=js&"
import style0 from "./CompetitionSelection.vue?vue&type=style&index=0&id=a1c24ed0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1c24ed0",
  null
  
)

export default component.exports